/**
 * Utility function for fetching user options based on route context
 */
/**
 * Get user list options based on route (admin vs regular)
 * @param {Object} context - Vue component instance (this)
 * @returns {Promise<Array>} - Promise resolving to array of user options
 */
export async function getUserOptions(context) {
    const isAdminRoute = context.$route.matched.some((r) => r.name === 'Admin');

    if (isAdminRoute) {
        try {
            const response = await context.$getData('user/consultant/read');
            if (response?.success) {
                return response.data.map((user) => ({
                    text: `${user.first_name} ${user.last_name}`,
                    value: String(user.id),
                }));
            } else {
                context.$alertStore.pushError(response.message);
                return [];
            }
        } catch (error) {
            context.$alertStore.pushError('Failed to load user options');
            return [];
        }
    } else {
        return new Promise((resolve) => {
            context.$employeesStore.sync(() => {
                resolve(context.$employeesStore.getEmployeeOptions());
            });
        });
    }
}
